import { providersService } from '../services';

export const Marca = async () => {
  const { data } = await providersService.getBrand();
  return data;
};
